// extracted by mini-css-extract-plugin
export default {"language":"languages_language__+R9yq","popup":"languages_popup__s8x6e","languageItem":"languages_languageItem__d9udg"};